import { defineComponent } from 'vue'
import { useMessage } from 'naive-ui'
import { useStore } from '@gx-vuex'
import email from '@/assets/email/email.png'
import { subscribeEmail } from '@/services/picDetails'
import { checkEmail, getUUID } from '@/utils/util'

import styles from './style.module.less'

export default defineComponent({
  name: 'PcEmail',
  setup() {
    const store = useStore()
    const { success, warning } = useMessage()

    const emailValue = ref('')
    const isShow = ref(true)
    const submitLoading = ref(false)

    const handleChange = (e: any) => {
      emailValue.value = e.target.value
    }

    const submitEmail = async () => {
      if (checkEmail(emailValue.value)) {
        if (submitLoading.value) return
        submitLoading.value = true
        const response: ResponseResult<{
          status: 1 | 2
        }> = await subscribeEmail({ email: emailValue.value, deviceId: getUUID('PeoplesDaily') })

        if (response.data?.status === 1) {
          try {
            const commonDetails = store.point.getPublicDetails()
            window.sensors.track('NameClick', {
              page_name: commonDetails.details.newsType == '8'
                ? global.page_name.article_detail_page
                : commonDetails.details.newsType == '9' ?
                  global.page_name.atlas_detail_page : commonDetails.details.newsType == '10' ?
                    global.page_name.operation_page : commonDetails.details.newsType == '1' ?
                      global.page_name.video_detail_page : commonDetails.details.newsType == '2' ?
                        global.page_name.live_detail_page : '',
              page_id: commonDetails.mainParent.pageId,
              mail_address: emailValue.value,
              click_name: 'subscribe_submit',
              ...store.point.getCommonOptions()
            })
          } catch (e) {}

          emailValue.value = ''
          warning('Already submitted')
        } else if (response.data?.status === 2) {
          emailValue.value = ''
          isShow.value = false
          success('Submission successful')
        }

        submitLoading.value = false
      } else {
        emailValue.value = ''
        warning('Please enter a valid email address')
      }
    }

    return () => {
      return (
        <>
          {isShow.value && (
            <div class={styles.email}>
              <div class={styles.title}>Subscribe now</div>
              <div class={styles.container}>
                <div class={styles.searchInput}>
                  <div class={styles.left}>
                    <input type="email" placeholder="Please enter your email" value={emailValue.value} onChange={(e) => handleChange(e)} />
                    <div class={styles.btn} onClick={() => submitEmail()}>
                      Submit
                    </div>
                  </div>
                  <div class={styles.right}>
                    <img src={email} alt="email" class={'w-50px h-50px'} />
                  </div>
                </div>
                <div class={styles.searchService}>
                  By submitting, you agree to our&nbsp;
                  <a href="/aboutUs" target="_blank" rel="noopener noreferrer">
                    Terms Of Service
                  </a>
                </div>
              </div>
            </div>
          )}
        </>
      )
    }
  }
})
